import { get, post, put, del } from "../client";
import { BASE_URL } from "../../config";
import {
  GET_FORMS, GET_FORM, CREATE_FORM, UPDATE_FORM, DELETE_FORM, TOGGLE_FORM,
  SEND_FORM_LINK, GET_FORM_SUBMISSIONS, GET_FORM_SUBMISSION,
  GET_FORM_LINKS, GET_CLIENT_FORM_LINKS,
  FORM_RESIGN_ALL, FORM_BULK_SEND, FORM_ALL_LINKS, FORM_SUBMISSION_NOTES, FORM_SUBMISSION_NOTE_DELETE,
} from "../routes";

const FORMS = {
  list: (type) => get(GET_FORMS(type)),
  getOne: (id) => get(GET_FORM(id)),
  create: (data) => post(CREATE_FORM, data),
  update: (id, data) => put(UPDATE_FORM(id), data),
  remove: (id) => del(DELETE_FORM(id)),
  toggle: (id) => put(TOGGLE_FORM(id)),
  sendLink: (data) => post(SEND_FORM_LINK, data),
  submissions: (id, page = 1, limit = 50) => get(GET_FORM_SUBMISSIONS(id, page, limit)),
  submission: (formId, submissionId) => get(GET_FORM_SUBMISSION(formId, submissionId)),
  links: (id) => get(GET_FORM_LINKS(id)),
  clientLinks: (clientId) => get(GET_CLIENT_FORM_LINKS(clientId)),

  // Phase 1 extensions — bulk re-sign + admin notes on submissions.
  resignAll: (id) => post(FORM_RESIGN_ALL(id), {}),
  bulkSend: (id, audience) => post(FORM_BULK_SEND(id), { audience }),
  allLinks: () => get(FORM_ALL_LINKS),
  addNote: (formId, submissionId, text) =>
    post(FORM_SUBMISSION_NOTES(formId, submissionId), { text }),
  deleteNote: (formId, submissionId, noteId) =>
    del(FORM_SUBMISSION_NOTE_DELETE(formId, submissionId, noteId)),

  printUrl: (formId, submissionId) => {
    const raw = localStorage.getItem("token");
    const token = raw ? JSON.parse(raw) : null;
    const t = token ? `?token=${encodeURIComponent(token)}` : "";
    return `${BASE_URL}/forms/${formId}/submissions/${submissionId}/print${t}`;
  },
  previewUrl: (formId, submissionId) => {
    const raw = localStorage.getItem("token");
    const token = raw ? JSON.parse(raw) : null;
    const t = token ? `?token=${encodeURIComponent(token)}&noprint=1` : "?noprint=1";
    return `${BASE_URL}/forms/${formId}/submissions/${submissionId}/print${t}`;
  },
  pdfUrl: (formId, submissionId) => {
    const raw = localStorage.getItem("token");
    const token = raw ? JSON.parse(raw) : null;
    const t = token ? `?token=${encodeURIComponent(token)}` : "";
    return `${BASE_URL}/forms/${formId}/submissions/${submissionId}/pdf${t}`;
  },
};

export default FORMS;
